import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { SedeService } from '@app/services/sede.service';
import { NotificationService } from '@app/services/notification/notification.service';
import { Sede } from '@src/app/models/backend/sede/sede.model';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { CoachingListarUsuarioService } from '../../../../services/coaching.listar.usuario';
import { MatDialogRef } from '@angular/material/dialog';
import { TareaService } from '@src/app/services/tarea.service';
import { co } from '@fullcalendar/core/internal-common';
import { environment } from '@src/environments/environment';

export enum TipoAsignacion {
    TODOS = 'TODOS',
    SEDE = 'SEDE',
    COORDINACION = 'COORDINACION',
    PERSONAL = 'PERSONAL'
}

interface Usuario {
    codi_usuario: string;
    nombre: string;
    apellido: string;
    [key: string]: any; // por si hay más campos
}

@Component({
    selector: 'app-detalle-tarea',
    templateUrl: './detalle-tarea.component.html',
    styleUrls: ['./detalle-tarea.component.css'],
})

export class DetalleTareaComponent implements OnInit, OnDestroy {
    form!: FormGroup;
    tipoAsignacion = TipoAsignacion;
    usuariosLoaded: boolean = false;
    sedes: Sede[] = [];
    coordinadores: any[] = [];
    usuarios: any[] = [];
    loading = false;
    editorModules: any;
    private destroy$ = new Subject<void>();

    constructor(
        private fb: FormBuilder,
        private sedeService: SedeService,
        private notificationService: NotificationService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private http: HttpClient,
        private usuarioService: CoachingListarUsuarioService,
        private dialogRef: MatDialogRef<DetalleTareaComponent>,
        private tareaService: TareaService
    ) {
        this.form = this.fb.group({
            id_tarea: [this.data?.id || null],
            titulo: [this.data?.titulo || ''],
            tipoAsignacion: [this.data?.tipo_asignacion || TipoAsignacion.TODOS, Validators.required],
            sedeId: [null],
            coordinadorId: [null],
            usuarioId: [[]],
            asignado_a: [this.data?.asignado_a || ''],
            descripcionAsignacion: [this.data?.descripcion || '', Validators.required],
        });


    }


    ngOnInit(): void {

        this.form.get('tipoAsignacion')?.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe(value => {
                // Limpiar campos dependientes
                this.form.patchValue({
                    sedeId: null,
                    coordinadorId: null,
                    usuarioId: []
                });

                if (value === TipoAsignacion.SEDE) {
                    this.loadSedes();
                } else if (value === TipoAsignacion.COORDINACION) {
                    this.cargarCoordinadores();
                } else if (value === TipoAsignacion.PERSONAL) {
                    this.loadUsuarios();
                }
            });


        //para ver el valor seleccionado del coordinador
        this.form.get('coordinadorId')?.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe(value => {
                const seleccionado = this.coordinadores.find(c => c.codi_usuario === value);
                console.log('ID:', value);
                console.log('Nombre:', seleccionado?.nombreCoordinador || 'No encontrado');
            });

        this.form.get('usuarioId')?.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((ids: number[]) => {
                const seleccionados = this.usuarios.filter(u => ids.includes(u.codi_usuario));
                console.log('Usuarios seleccionados:', seleccionados);
            });

        this.editorModules = {
            toolbar: [
                [{ font: [] }, { size: [] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ color: [] }, { background: [] }],
                [{ script: 'sub' }, { script: 'super' }],
                [{ header: 1 }, { header: 2 }, 'blockquote', 'code-block'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ indent: '-1' }, { indent: '+1' }],
                [{ align: [] }],
                ['link', 'image', 'video'],
                ['clean']
            ]
        };

        this.preloadAsignado();
    }

    onSubmit(): void {
        if (this.form.invalid) return;

        const formValue = this.form.value;
        const tipo = formValue.tipoAsignacion;
        let asignado_a = '';

        console.log('🟡 Datos del formulario antes de preparar asignado_a:', formValue);

        // Validaciones según tipo
        if (tipo === 'SEDE' && !formValue.sedeId) {
            Swal.fire('Campo requerido', 'Debe seleccionar una sede.', 'warning');
            return;
        }

        if (tipo === 'COORDINACION' && !formValue.coordinadorId) {
            Swal.fire('Campo requerido', 'Debe seleccionar un coordinador.', 'warning');
            return;
        }

        if (tipo === 'PERSONAL' && (!formValue.usuarioId || formValue.usuarioId.length === 0)) {
            Swal.fire('Campo requerido', 'Debe seleccionar al menos un usuario.', 'warning');
            return;
        }

        // Generar asignado_a
        switch (tipo) {
            case 'SEDE':
                asignado_a = String(formValue.sedeId);
                break;
            case 'COORDINACION':
                asignado_a = String(formValue.coordinadorId);
                break;
            case 'PERSONAL':
                asignado_a = formValue.usuarioId.map((id: number | string) => String(id)).join(',');
                break;
        }

        console.log('🟢 asignado_a generado:', asignado_a);

        const tareaActualizada = {
            id_tarea: formValue.id || this.data?.id,
            titulo: formValue.titulo,
            descripcion: formValue.descripcionAsignacion,
            tipo_asignacion: tipo,
            asignado_a: asignado_a
        };

        console.log('🔵 Enviando payload a editarTarea():', tareaActualizada);

        this.tareaService.editarTarea(tareaActualizada).subscribe({
            next: () => {
                console.log('✅ Tarea editada correctamente');
                this.dialogRef.close(true);
            },
            error: err => {
                console.error('❌ Error al editar tarea:', err);
                Swal.fire('Error', 'Ocurrió un error al editar la tarea.', 'error');
            }
        });
    }




    loadUsuarios(callback?: () => void): void {
    if (this.usuariosLoaded && this.usuarios.length > 0) {
        callback?.();
        return;
    }

    this.loading = true;

    this.usuarioService.obtenerUsuariosAsesores().subscribe({
        next: (resp) => {
            this.usuarios = (resp.data || []).map((u: Usuario) => ({
                ...u,
                nombreCompleto: `${u.nombre} ${u.apellido}`
            }));
            this.usuariosLoaded = true;
            this.loading = false;
            callback?.();
        },
        error: (err) => {
            this.loading = false;
            console.error('Error al cargar usuarios', err);
        }
    });
}


    cargarCoordinadores(callback?: () => void): void {
        if (this.coordinadores.length > 0) {
            callback?.();
            return;
        }

        this.loading = true;

        this.http.get<any>(`${environment.urlVentas}coordinadores/listado/`).subscribe({
            next: (res) => {
                this.coordinadores = res?.data ?? [];
                this.loading = false;
                callback?.();
            },
            error: (err) => {
                this.loading = false;
                console.error('Error al cargar coordinadores', err);
            }
        });
    }



    private loadSedes(callback?: () => void): void {
        if (this.sedes.length > 0) {
            callback?.();
            return;
        }

        this.loading = true;

        this.sedeService.getAllSedes().pipe(takeUntil(this.destroy$)).subscribe({
            next: (response: any) => {
                this.sedes = response.data || [];
                this.loading = false;
                callback?.();
            },
            error: (error: any) => {
                console.error('Error al cargar sedes:', error);
                this.notificationService.error('Error al cargar sedes');
                this.loading = false;
            }
        });
    }

    private preloadAsignado(): void {
        const tipo = this.data?.tipo_asignacion;
        const asignado = this.data?.asignado_a;

        switch (tipo) {
            case TipoAsignacion.SEDE:
                this.loadSedes(() => {
                    this.form.get('sedeId')?.setValue(Number(asignado));
                });
                break;

            case TipoAsignacion.COORDINACION:
                this.cargarCoordinadores(() => {
                    this.form.get('coordinadorId')?.setValue(Number(asignado));
                });
                break;

            case TipoAsignacion.PERSONAL:
                this.loadUsuarios(() => {
                    const ids = asignado?.split(',').map((id: string) => Number(id)) || [];
                    this.form.get('usuarioId')?.setValue(ids);
                });
                break;
        }
    }


    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
